export default "__VITE_ASSET__96a62734__"